module.exports = __webpack_public_path__ + "img/story-mode-long1.ae8c9bdf.svg";